import {api} from "./api";

export const newActivityInstance=()=>globalThis.crypto?.randomUUID?.()||`activity-${Date.now()}-${Math.random().toString(36).slice(2)}`;
export const recordActivity=(event,instanceId=newActivityInstance())=>{
  const request=api.post("/audit/activity",{...event,instance_id:instanceId});
  if(typeof request?.catch==="function") request.catch(()=>{});
  return instanceId;
};
